var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-space-between my-1",staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"width":"100%"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{class:_vm.contentClass,staticStyle:{"width":"100%"}},[_vm._v(" "+_vm._s(_vm.contentText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }